<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">
    @for (line of hexaBoard; track $index; let y = $index) {
        <g>
            @for (space of line; track $index; let x = $index) {
                <g>
                    @if (space.isReachable()) {
                        <g id="click-{{ x }}-{{ y }}"
                           (click)="onClick(x, y)">
                            <polygon id="space-{{ x }}-{{ y }}"
                                     [attr.points]="getHexaPoints()"
                                     [attr.transform]="getHexaCenterTranslationAtXY(x, y)"
                                     [ngClass]="getSpaceClasses(x, y)"
                                     class="base"
                                     stroke-linecap="round"/>
                            <g id="piece-group-{{ x }}-{{ y }}"
                               [ngClass]="getPieceGroupClasses(x, y)"
                               [attr.transform]="getSVGTranslationAt(getCenterAtXY(x, y))">
                                @if (isRing(x, y)) {
                                    <g app-ring
                                       id="ring-{{ x }}-{{ y }}"
                                       transform="scale(0.43)"
                                       [strokeWidth]="10"
                                       [width]="20"
                                       [midRingClasses]="getRingClasses(x, y)">
                                    </g>
                                }
                                @if (isMarker(x, y)) {
                                    <circle id="marker-{{ x }}-{{ y }}"
                                            [attr.r]="viewInfo.markerSize"
                                            [ngClass]="getMarkerClasses(x, y)"
                                            class="base mid-stroke"/>
                                }
                            </g>
                        </g>
                    }
                </g>
            }
        </g>
    }
    @for (coord of selectedCoords.union(selectedRings); track coord.toString()) {
        <polygon id="selected-{{ coord.x }}-{{ coord.y }}"
                 (click)="onClick(coord.x, coord.y)"
                 class="base no-fill selected-stroke"
                 [attr.points]="getHexaPoints()"
                 [attr.transform]="getHexaCenterTranslationAt(coord)"
                 pointer-events="fill"
                 stroke-linecap="round"/>
    }
    @if (isPlayerTurn()) {
        <g>
            @for (coord of selectableCoords; track coord.toString()) {
                <polygon id="selectable-{{ coord.x }}-{{ coord.y }}"
                         (click)="onClick(coord.x, coord.y)"
                         class="base no-fill capturable-stroke"
                         [attr.points]="getHexaPoints()"
                         [attr.transform]="getHexaCenterTranslationAt(coord)"
                         pointer-events="fill"
                         stroke-linecap="round"/>
            }
        </g>
    }
    @for (coord of viewInfo.targets; track coord.toString()) {
        <rect id="indicator-{{ coord.x }}-{{ coord.y }}"
              [attr.transform]="getSVGTranslationAt(getCenterAt(coord))"
              [attr.x]=" - viewInfo.indicatorSize/2"
              [attr.y]=" - viewInfo.indicatorSize/2"
              [attr.width]="viewInfo.indicatorSize"
              [attr.height]="viewInfo.indicatorSize"
              (click)="onClick(coord.x, coord.y)"
              class="indicator"/>
    }
    @for (player of Player.PLAYERS; track player.getValue()) {
        <g [attr.transform]="'rotate(' + ((getPointOfView().getValue() + 1) * 180) + ' 532.5 780)'">
            @for (_ of [].constructor(viewInfo.sideRings.get(player)); track $index; let ring = $index) {
                <g app-ring
                   id="{{ player.toString() }}-side-ring-{{ ring + 1 }}"
                   [attr.transform]="translateRing(player, ring) + 'scale(0.43)'"
                   [strokeWidth]="10"
                   [width]="20"
                   [midRingClasses]="viewInfo.sideRingClass.get(player)">
                </g>
            }
        </g>
    }

</svg>
